import React from "react";
import { Link } from "react-router-dom";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Checkbox from "material-ui/Checkbox";
import Icon from "material-ui/Icon";
import Tooltip from "material-ui/Tooltip";
import Menu, { MenuItem } from "material-ui/Menu";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormLabel, FormControl, FormControlLabel } from "material-ui/Form";
import { connect } from "react-redux";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import ListAttachments from "../jobandtestattachments/list";
import UploadAttachment from "../jobandtestattachments/add";
import SmartFlagsModal from "../../job/smart-flags-modal";

class ResultsHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      jobAttachmentsModal: false,
      uploadModal: false,
      jobid: null,
      testid: null,
      smartFlagsModalOpen: false
    };
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  showUplaodModal = () => {
    this.setState({
      uploadModal: true
    });
  };

  showAttachments = e => {
    e.preventDefault();
    const { jobid, testid } = this.props;
    this.setState({
      jobAttachmentsModal: true
    });
  };

  hideAttachments = e => {
    this.setState({
      jobid: null,
      testid: null,
      jobAttachmentsModal: false
    });
  };

  closeModal = reset => {
    this.setState({
      jobid: null,
      testid: null,
      jobAttachmentsModal: false
    });
  };

  hideUplaodModal = () => {
    this.setState({
      uploadModal: false
    });
  };

  uploadFile = file => {
    const { jobid, testid } = this.props;
    const { uploadAttachment } = this.props;
    uploadAttachment(file, jobid, testid);
  };

  openSmartFlagsModal = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.setState({ smartFlagsModalOpen: true });
  };

  closeSmartFlagsModal = () => {
    this.setState({ smartFlagsModalOpen: false });
  };

  render() {
    const {
      classes,
      translate,
      results,
      job,
      nextTestId,
      previousTestId,
      currentTestIndex,
      total,
      subtest,
      handleChartLineChange,
      handleChartMeasurementChange,
      handleChartMeasurementUnitChange,
      handleShowMargin,
      handleWiremapStandardChange,
      chartLineStyle,
      chartMeasurement,
      chartMeasurementUnit,
      wiremapStandard,
      showMargin,
      attachments,
      getAttachments,
      uploadAttachment,
      deleteAttachment,
      attachmentDownload,
      jobid,
      testid,
      pager,
      smartFlagChecks,
      smartFlagEvaluatedTestIds,
      clearAttachments,
      showResults,
      fileUploadSettings
    } = this.props;
    const { smartFlagsModalOpen } = this.state;
    const currentTestId = pager && pager.tid;
    const currentTestChecks = Array.isArray(smartFlagChecks)
      ? smartFlagChecks.filter(
          check => String(check.testId || check.TestId) === String(currentTestId)
        )
      : [];
    const hasSmartFlagFailure = currentTestChecks.length > 0;
    const hasSmartFlagEvaluation =
      Array.isArray(smartFlagEvaluatedTestIds) &&
      smartFlagEvaluatedTestIds.some(id => String(id) === String(currentTestId));

    let $jobAttachmentsModal = this.state.jobAttachmentsModal ? (
      <ListAttachments
        translate={translate}
        close={this.closeModal}
        jobid={jobid}
        testid={testid}
        attachments={attachments}
        getAttachments={getAttachments}
        hideUplaodModal={this.hideUplaodModal}
        showUplaodModal={this.showUplaodModal}
        deleteAttachment={deleteAttachment}
        attachmentDownload={attachmentDownload}
        clearAttachments={clearAttachments}
      />
    ) : null;

    let $fileUploadModal = this.state.uploadModal ? (
      <UploadAttachment
        translate={translate}
        jobid={jobid}
        testid={testid}
        hideUplaodModal={this.hideUplaodModal}
        uploadFile={this.uploadFile}
        fileUploadSettings={fileUploadSettings}
      />
    ) : null;

    const { anchorEl } = this.state;
    const isMobileTest = results.data.mobileTest != null;
    const hasSubtestDropdown =
      results.data &&
      results.data.testedcabletype !== "Fiber" &&
      results.data.testedcabletype !== "FiberCable";

    return (
      <Paper
        className={`${results.data.devicetype === "Comet" && showResults ? classes.cometPaper : classes.paper} ${
          results.data && results.data.status === "Pass"
            ? classes.success
            : results.data && results.data.status === "Fail"
            ? classes.fail
            : classes.unknown
        }`}
      >
        <Grid container spacing={16}>
          <Grid
            className={classes.resultNav}
            item
            xs={2}
            sm={2}
            md={1}
            lg={1}
            xl={1}
          >
            <div className={classes.nav}>
              <Button
                color="#FF643B"
                fab
                className={classes.back}
                mini
                disabled={previousTestId === null}
                component={Link}
                to={`/results/${job.id}/${previousTestId}`}
              >
                <Icon>arrow_upward</Icon>
              </Button>
              &nbsp;
              <Button
                color="#FF643B"
                fab
                className={classes.forward}
                mini
                disabled={nextTestId === null}
                component={Link}
                to={`/results/${job.id}/${nextTestId}`}
              >
                <Icon>arrow_downward</Icon>
              </Button>
            </div>
          </Grid>
          <Grid
            className={`${classes.resultBar} ${classes.resultNameBar}`}
            item
            xs={2}
            sm={2}
            md={3}
            lg={3}
            xl={3}
          >
            <Typography
              type="subheading"
              className={`${classes.headerText} ${classes.resultNameText}`}
            >
              {results.data ? results.data.name : ""}
            </Typography>
          </Grid>
          <Grid
            className={`${classes.resultBar} ${classes.resultStatusBar}`}
            item
            xs={2}
            sm={2}
            lg={2}
            md={2}
            xl={2}
          >
            <Typography className={classes.status} type="button" gutterBottom>
              {/* {results.data.status}&nbsp;<Icon>{results.data.status === 'Pass' ? 'check_circle' : 'cancel'}</Icon> */}
              {results.data &&
                results.data.status &&
                translate(results.data.status.toLowerCase())}
              {hasSmartFlagFailure && (
                <Tooltip
                  title={translate("smart_flags_label")}
                  disableTriggerFocus={true}
                >
                  <Button
                    aria-label={translate("smart_flags_label")}
                    className={classes.smartFlagButton}
                    onClick={this.openSmartFlagsModal}
                  >
                    <Icon className={classes.smartFlagFailIcon}>flag</Icon>
                  </Button>
                </Tooltip>
              )}
              {!hasSmartFlagFailure && hasSmartFlagEvaluation && (
                <Tooltip
                  title={translate("smart_flags_label")}
                  disableTriggerFocus={true}
                >
                  <Button
                    aria-label={translate("smart_flags_label")}
                    className={classes.smartFlagButton}
                    disabled
                  >
                    <Icon className={classes.smartFlagPassIcon}>flag</Icon>
                  </Button>
                </Tooltip>
              )}
            </Typography>
          </Grid>
          <Grid
            className={`${classes.resultBar} ${classes.resultCountBar}`}
            item
            xs={2}
            sm={2}
            lg={2}
            md={2}
            xl={2}
          >
            <Typography
              type="subheading"
              className={`${classes.headerText} ${classes.resultCountText}`}
            >
              {currentTestIndex && total
                ? `${translate("general_test")} ${currentTestIndex} ${translate(
                    "general_of"
                  )} ${total}`
                : ""}
            </Typography>
          </Grid>
          <Grid
            className={`${classes.resultBarDropDown} ${classes.resultDropdownBar} ${
              hasSubtestDropdown ? "" : classes.resultDropdownHidden
            }`}
            item
            xs={2}
            sm={2}
            lg={2}
            md={2}
            xl={2}
          >
            {hasSubtestDropdown && (
              <Select
                value={subtest}
                onChange={e => this.props.onChange(e.target.value)}
                autoWidth={true}
                className={classes.resultsDD}
                disabled={isMobileTest}
              >
                <MenuItem key={-1} value={"Summary"}>
                  {translate("summary")}
                </MenuItem>
                {/* results.data && results.data.testedcabletype &&
                  results.data.testedcabletype.toLowerCase() != "coaxialcable"
                  && */}
                {results.data &&
                  results.data.testedcabletype &&
                  results.data.testedcabletype.toLowerCase() !=
                    "coaxialcable" &&
                  results.data.subtests &&
                  results.data.subtests.map((subtest, index) => {
                    if (
                      subtest.subtesttype === "CDNEXT" ||
                      subtest.subtesttype === "CMRL"
                    ) {
                    } else {
                      return (
                        <MenuItem key={index} value={subtest.subtesttype}>
                          {translate(subtest.subtesttype)}
                        </MenuItem>
                      );
                    }
                  })}

                  {results.data &&
                    results.data.testedcabletype &&
                    results.data.testedcabletype.toLowerCase() !=
                      "coaxialcable" &&
                    results.data.othersubtests &&
                    results.data.othersubtests.map((subtest, index) => {
                      if (subtest.subtesttype.toLowerCase() !== "headroom")
                        return (
                          <MenuItem key={index} value={subtest.subtesttype}>
                            {translate(subtest.subtesttype)}
                          </MenuItem>
                        );
                    })}
                  {results.data &&
                    results.data.testedcabletype &&
                    results.data.testedcabletype.toLowerCase() ==
                      "coaxialcable" &&
                    results.data.othersubtests &&
                    results.data.othersubtests.map((subtest, index) => {
                      if (subtest.subtesttype.toLowerCase() === "wiremap")
                        return (
                          <MenuItem key={index} value={subtest.subtesttype}>
                            {translate(subtest.subtesttype)}
                          </MenuItem>
                        );
                    })}
                  {results.data &&
                    results.data.testedcabletype &&
                    results.data.testedcabletype.toLowerCase() ==
                      "coaxialcable" &&
                    results.data.othersubtests &&
                    results.data.othersubtests.map((subtest, index) => {
                      if (subtest.subtesttype.toLowerCase() === "length")
                        return (
                          <MenuItem key={index} value={subtest.subtesttype}>
                            {translate(subtest.subtesttype)}
                          </MenuItem>
                        );
                    })}
                  {results.data &&
                    results.data.testedcabletype &&
                    results.data.testedcabletype.toLowerCase() ==
                      "coaxialcable" &&
                    results.data.othersubtests &&
                    results.data.othersubtests.map((subtest, index) => {
                      if (
                        subtest.subtesttype.toLowerCase() === "propagationdelay"
                      )
                        return (
                          <MenuItem key={index} value={subtest.subtesttype}>
                            {translate(subtest.subtesttype)}
                          </MenuItem>
                        );
                    })}
                  {results.data &&
                    results.data.testedcabletype &&
                    results.data.testedcabletype.toLowerCase() ==
                      "coaxialcable" &&
                    results.data.othersubtests &&
                    results.data.othersubtests.map((subtest, index) => {
                      if (subtest.subtesttype.toLowerCase() === "resistance")
                        return (
                          <MenuItem key={index} value={subtest.subtesttype}>
                            {translate(subtest.subtesttype)}
                          </MenuItem>
                        );
                    })}
                  {results.data &&
                    results.data.testedcabletype &&
                    results.data.testedcabletype.toLowerCase() ==
                      "coaxialcable" &&
                    results.data.othersubtests &&
                    results.data.othersubtests.map((subtest, index) => {
                      if (subtest.subtesttype.toLowerCase() === "impedance")
                        return (
                          <MenuItem key={index} value={subtest.subtesttype}>
                            {translate(subtest.subtesttype)}
                          </MenuItem>
                        );
                    })}
                  {results.data &&
                    results.data.testedcabletype &&
                    results.data.testedcabletype.toLowerCase() ==
                      "coaxialcable" &&
                    results.data.subtests &&
                    results.data.subtests.map((subtest, index) => {
                      if (
                        subtest.subtesttype === "ATTEN" ||
                        subtest.subtesttype === "RTNLOSS" ||
                        subtest.subtesttype === "TDRTNLOSS"
                      ) {
                        return (
                          <MenuItem key={index} value={subtest.subtesttype}>
                            {translate(subtest.subtesttype)}
                          </MenuItem>
                        );
                      } else {
                      }
                    })}

                  {/* {results.data.othersubtests.find(x => x.subtesttype === 'Wiremap') && (
                  <MenuItem
                    value={'Wiremap'}
                  >
                    {translate('Wiremap')}
                  </MenuItem>
                )} */}
                </Select>
              )}
          </Grid>
          <Grid
            className={classes.resultActions}
            item
            xs={1}
            sm={1}
            lg={1}
            md={1}
            xl={1}
          >
            <Tooltip
              title={translate("tooltip_chart_settings")}
              disableTriggerFocus={true}
            >
              <Button
                aria-label="Chart Settings"
                aria-owns={anchorEl ? "chart-settings-menu" : null}
                aria-haspopup="true"
                className={`${classes.chartSettings} ${classes.compactActionButton}`}
                onClick={this.handleClick}
                disabled={isMobileTest}
              >
                <Icon color="#FFFFFF">insert_chart</Icon>
              </Button>
            </Tooltip>
            {subtest === "Wiremap" ? (
              <Menu
                id="chart-settings-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                {results.data &&
                  results.data.testedcabletype &&
                  results.data.testedcabletype.toLowerCase() !=
                    "coaxialcable" && (
                    <MenuItem className={classes.menuItem}>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <RadioGroup
                          aria-label="wiremapStandard"
                          name="wiremapStandard"
                          className={classes.group}
                          value={wiremapStandard}
                          onChange={handleWiremapStandardChange}
                        >
                          <FormControlLabel
                            value="Standard"
                            control={<Radio />}
                            label={translate("chart_line_standard")}
                          />
                          <FormControlLabel
                            value="568A"
                            control={<Radio />}
                            label={translate("568-A")}
                          />
                          <FormControlLabel
                            value="568B"
                            control={<Radio />}
                            label={translate("568-B")}
                          />
                          <FormControlLabel
                            value="TERA"
                            control={<Radio />}
                            label={translate("TERA")}
                          />
                        </RadioGroup>
                      </FormControl>
                    </MenuItem>
                  )}
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("chart_measurement_unit")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={
                        chartMeasurementUnit ? chartMeasurementUnit : "meters"
                      }
                      onChange={handleChartMeasurementUnitChange}
                    >
                      <FormControlLabel
                        value="meters"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_meter")}
                      />
                      <FormControlLabel
                        value="feet"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_feet")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
              </Menu>
            ) : (
              <Menu
                id="chart-settings-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("chart_line_style")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={chartLineStyle}
                      onChange={handleChartLineChange}
                    >
                      <FormControlLabel
                        value="standard"
                        control={<Radio />}
                        label={translate("chart_line_standard")}
                      />
                      <FormControlLabel
                        value="inverted"
                        control={<Radio />}
                        label={translate("chart_line_inverted")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("chart_measurements")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={chartMeasurement}
                      onChange={handleChartMeasurementChange}
                    >
                      <FormControlLabel
                        value="auto"
                        control={<Radio />}
                        label={translate("chart_line_standard")}
                      />
                      <FormControlLabel
                        value="log"
                        control={<Radio />}
                        label={translate("chart_line_logarithmic")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("chart_measurement_unit")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={chartMeasurementUnit}
                      onChange={handleChartMeasurementUnitChange}
                    >
                      <FormControlLabel
                        value="meters"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_meter")}
                      />
                      <FormControlLabel
                        value="feet"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_feet")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
                <MenuItem className={classes.menuItem}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showMargin}
                        onChange={handleShowMargin}
                        value="enableMarginValue"
                        color="primary"
                      />
                    }
                    label={translate("show_margin_values")}
                  />
                </MenuItem>
              </Menu>
            )}
            <Tooltip
              title={translate("tooltip_attach_files")}
              disableTriggerFocus={true}
            >
              <Button
                aria-label="Attach Files"
                aria-owns={anchorEl ? "chart-settings-menu" : null}
                aria-haspopup="true"
                className={`${classes.chartSettings} ${classes.compactActionButton} ${
                  results && results.data && results.data.attachmentexists
                    ? classes.attachmentExists
                    : ""
                }`}
                onClick={this.showAttachments}
              >
                <Icon color="#FFFFFF">attach_file</Icon>
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
        {$jobAttachmentsModal}
        {$fileUploadModal}
        <SmartFlagsModal
          testId={currentTestId}
          isOpen={smartFlagsModalOpen}
          onClose={this.closeSmartFlagsModal}
        />
      </Paper>
    );
  }
}

const mapStateToProps = state => ({
  smartFlagChecks: state.smartFlagReducer.smartFlagChecks,
  smartFlagEvaluatedTestIds: state.smartFlagReducer.smartFlagEvaluatedTestIds
});

export default connect(mapStateToProps)(withStyles(styles)(ResultsHeader));
